import { types } from "../typescript";

export const PIPELINE_DRUG_INDICATIONS: types.data.PipelineDrugIndications = {
  approvedIndications: [],
  clinicalIndications: [],
};

export const COLUMNS_SORT_ORDERS: types.table.ColumnSortOrder = {
  drugNames: "asc",
  brandCompanies: "asc",
  routesOfAdministration: "asc",
  mechanismsOfAction: "asc",
  indications: "asc",
  stages: "asc",
  submissionTypes: "asc",
};
